import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from "../../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { Avatar, Checkbox, CircularProgress, FormControlLabel, Menu, MenuItem, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GlobalTextfield from '../../../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalSymbols from '../../../../Utils/Layout/GlobalSymbols/GlobalSymbols';
import Icons from '../../../../Utils/Layout/Icons/Icons';
import { Global } from '@emotion/react';
import GlobalButton from '../../../../Utils/Layout/GlobalButton/GlobalButton';
import { MemberContext, MemberContextPayload } from '../../../../Context/MemberDetailsContext';
import { useSnackbar } from '../../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../../Context/GlobalUserDetailContext';
import agent from '../../../../Services/api';
import GlobalAutocomplate from '../../../../Utils/Layout/GlobalAutocomplate/GlobalAutoComplate';

function AcrylicNewMemberDialog(props: any) {

    const { setFlagOpenNewMemberDialog, selectedDropdownUser, isEditMode, initializeAcrylicTeamListAuth, onSaveSuccess } = props

    const {
        memberPayloadDetails,
        setMemberPayloadDetails,
        memberUserListDetails
    } = useContext(MemberContext) as MemberContextPayload

    const { setFlagLoader } = useContext(GlobalUserContext) as GlobalUserContextPayload
    const { showSnackbar } = useSnackbar();

    const imageInputRef = useRef<HTMLInputElement>(null);
    const [localSelectedUser, setLocalSelectedUser] = useState<number | null>(selectedDropdownUser ?? null);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [uploadFileId, setUploadFileId] = useState<number | null>(null)
    const [validationErrors, setValidationErrors] = useState({
        firstName: '',
        lastName: '',
        memberEmail: '',
        memberTitle: '',
        memberPhone: ''
    });
    const blankMemberPayload = {
        teamId: null,
        userId: null,
        firstName: "",
        lastName: "",
        memberTitle: "",
        memberEmail: "",
        memberPhone: "",
        image: 0,
        isDefault: false,
        description: ""
    };

    // useEffect(() => {
    //     if (!isEditMode) {
    //         const resolvedUserId =
    //             memberPayloadDetails?.userId ??
    //             memberPayloadDetails?.assignedToUserId ??
    //             selectedDropdownUser ??
    //             null;

    //         const shouldBeDefault = !resolvedUserId;

    //         setMemberPayloadDetails((prev: any) => ({
    //             ...prev,
    //             isDefault: shouldBeDefault,
    //             userId: shouldBeDefault ? null : resolvedUserId
    //         }));
    //     }
    // }, []);

    useEffect(() => {
        if (!memberPayloadDetails?.isDefault) {
            const resolvedUserId =
                memberPayloadDetails?.userId ??
                memberPayloadDetails?.assignedToUserId ??
                selectedDropdownUser ??
                null;

            setLocalSelectedUser(resolvedUserId);
        } else {
            setLocalSelectedUser(null);
        }
    }, [memberPayloadDetails?.userId, memberPayloadDetails?.assignedToUserId, memberPayloadDetails?.isDefault]);

    const handleInputChange = (key: any, value: any) => {
        setMemberPayloadDetails((prev: any) => ({
            ...prev,
            [key]: value
        }));

        setValidationErrors((prev) => ({
            ...prev,
            [key]: ''
        }));
    };

    const handleProfileEdit = () => {
        imageInputRef.current?.click();
        setAnchorEl(null)
    }

    const handleProfileMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setIsUploading(true);
        // await handleProfileDelete()
        const formData = new FormData();
        formData.append("file", file);

        const response = await agent.uploadResourceFileAPI.post(formData)

        if (response?.status) {
            const responseData = response?.data
            setIsUploading(false);
            setUploadFileId(responseData.google_storage_id)
            setMemberPayloadDetails({
                ...memberPayloadDetails,
                image: responseData?.google_storage_public_url
            })
        }
        else {
            console.error("Upload failed:", response);
            setIsUploading(false);
        }

        e.target.value = ""
    }

    const handleProfileDelete = async () => {
        setAnchorEl(null)
        if (!uploadFileId) return

        setIsUploading(true);
        if (uploadFileId) {
            const response = await agent.deleteResourceFileAPI.delete(uploadFileId);
            if (response?.status) {
                setIsUploading(false);
                setUploadFileId(0)
                setMemberPayloadDetails({
                    ...memberPayloadDetails,
                    image: ""
                })
            }
            else {
                console.error("Upload failed:", response);
                setIsUploading(false);
            }
        }
    }

    const handleSaveNewMemberDetails = async () => {

        const { firstName, lastName, memberEmail, memberTitle, memberPhone, isDefault, description, image, teamId, userId } = memberPayloadDetails;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d+$/;

        const errors: typeof validationErrors = {
            firstName: !firstName.trim() ? "First Name is required" : '',
            lastName: !lastName.trim() ? "Last Name is required" : '',
            memberEmail: !memberEmail.trim() ? "Email is required" : !emailRegex.test(memberEmail) ? "Invalid email format" : '',
            memberTitle: !memberTitle.trim() ? "Designation is required" : '',
            memberPhone: !memberPhone.trim() ? "Phone number is required" : !phoneRegex.test(memberPhone) ? "Only numbers allowed" : ''
        };

        setValidationErrors(errors);
        const hasError = Object.values(errors).some(error => error);
        if (hasError) return;

        const isEditMode = !!teamId;
        const payload = isEditMode
            ? {
                acrylicTeamId: teamId,
                firstName,
                lastName,
                memberTitle,
                memberEmail,
                memberPhone,
                image: image ? uploadFileId : 0,
                description
            }
            : {
                assignedToUserId: userId,
                firstName,
                lastName,
                memberTitle,
                memberEmail,
                memberPhone,
                image: image ? uploadFileId : 0,
                isDefault,
                description
            };

        setFlagLoader(true);
        const response = isEditMode ? await agent.updateAcrylicTeamApi.put(payload) : await agent.addAcrylicTeamApi.post(payload);
        if (response?.status) {
            const reloadUserId = userId ?? selectedDropdownUser ?? null;
            if (onSaveSuccess) {
                onSaveSuccess(reloadUserId);
            }
            // await initializeAcrylicTeamListAuth(reloadUserId);
            const successmessage = response?.message || 'Acrylic team added successfully!';
            showSnackbar(successmessage, 'success');
            setMemberPayloadDetails(blankMemberPayload);
            setFlagOpenNewMemberDialog(false)
            setFlagLoader(false);
        }
        else {
            console.error("Upload failed:", response);
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
            setFlagOpenNewMemberDialog(false)
        }
    }

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        handleInputChange("isDefault", checked);
        if (checked) {
            setLocalSelectedUser(null);
            handleInputChange("userId", null);
        } else {
            setLocalSelectedUser(selectedDropdownUser ?? null);
            handleInputChange("userId", selectedDropdownUser ?? null);
        }
    };


    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }} sx={{ margin: '20px 0px' }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ margin: '0px 0px 20px' }}>
                            <Grid container sx={{ justifyContent: 'space-between' }}>
                                <Grid
                                    size={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 12 }}
                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}
                                    sx={{ margin: { xs: "0px 0px 15px 0px", sm: "0px 0px" } }}
                                >
                                    User Info
                                </Grid>
                                <Grid size={{ xl: 9, lg: 9, md: 9, sm: 9, xs: 12 }}>
                                    <Grid container sx={{ justifyContent: 'space-between', gap: "10px", rowGap: '25px' }}>
                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                    Set as Default
                                                    <Tooltip
                                                        title="Apply this team to every user."
                                                        arrow
                                                        placement="top"
                                                        componentsProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: '#0087FF',
                                                                    color: '#fff',
                                                                    borderRadius: '8px',
                                                                    padding: '12px',
                                                                    fontSize: '13px',
                                                                    maxWidth: 300
                                                                }
                                                            },
                                                            arrow: {
                                                                sx: {
                                                                    color: '#0087FF'
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <InfoOutlinedIcon sx={{ fontSize: 18, color: '#ccc', cursor: 'pointer', verticalAlign: 'sub', ml: '5px' }} />
                                                    </Tooltip>
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12 }}>
                                                <FormControlLabel
                                                    label=""
                                                    className={styles.signinCheckboxLabel}
                                                    sx={{
                                                        cursor: isEditMode ? "not-allowed !important" : "pointer",
                                                    }}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            checked={memberPayloadDetails?.isDefault}
                                                            icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                            checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                            sx={{ padding: "0px 8px", "& .Mui-disabled": { backgroundColor: (isEditMode || memberPayloadDetails?.isDefault) ? "#c7c6c6" : "white" } }}
                                                            onChange={handleCheckboxChange}
                                                            disabled={isEditMode}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                    User
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12 }}>
                                                <GlobalAutocomplate
                                                    size="small"
                                                    fullWidth
                                                    placeholder="Select User"
                                                    disabled={isEditMode || memberPayloadDetails?.isDefault}
                                                    sx={{
                                                        maxHeight: 300,
                                                        "& .MuiInputBase-input": { cursor: (isEditMode || memberPayloadDetails?.isDefault) ? "not-allowed" : "pointer" },
                                                        "& .Mui-disabled": { backgroundColor: (isEditMode || memberPayloadDetails?.isDefault) ? "#c7c6c6" : "white" }
                                                    }}
                                                    options={memberUserListDetails?.users?.map((ele) => ({ label: ele.email, value: ele.userId })) || []}
                                                    // value={
                                                    //     memberUserListDetails?.users?.map((ele) => ({ label: ele.email, value: ele.userId })).find((opt) => opt.value == localSelectedUser) || null
                                                    // }
                                                    value={
                                                        memberPayloadDetails?.isDefault ? null : memberUserListDetails?.users?.map((ele) => ({ label: ele.email, value: ele.userId })).find((opt) => opt.value == localSelectedUser) || null
                                                    }

                                                    onChange={(event, newValue) => {
                                                        const selectedId = (newValue as any)?.value || null;
                                                        setLocalSelectedUser(selectedId);
                                                        handleInputChange("userId", selectedId);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`}>
                                {isEditMode ? "Edit Member Details" : "Add New Member"}
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: '20px 0px 0px' }}>
                            <Grid container sx={{ justifyContent: 'space-between' }}>
                                <Grid size={{ xl: 2, lg: 2, md: 2, sm: 2.5, xs: 6 }} className={styles.atAvtarItem}>
                                    <Grid container className={styles.memberProfileImageContainer} sx={{ height: "100%" }}>
                                        <Avatar
                                            src={memberPayloadDetails?.image ? memberPayloadDetails.image : ""}
                                            sx={{ width: "100%", height: "100%" }}
                                        />
                                        {isUploading &&
                                            <div style={{ position: "absolute", zIndex: 2, top: "50px", left: "50px" }}>
                                                <CircularProgress />
                                            </div>
                                        }
                                        <div className={styles.memberProfileEditImageItem} onClick={handleProfileMenuClick}>
                                            <Icons iconName="editIcon" iconHeight="28px" iconWidth="28px" />
                                        </div>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={() => { setAnchorEl(null); }}
                                        >
                                            <MenuItem onClick={handleProfileEdit}>
                                                Change Profile Picture
                                            </MenuItem>
                                        </Menu>
                                        <input
                                            id="avatar"
                                            accept="image/*"
                                            type="file"
                                            ref={imageInputRef}
                                            style={{ display: "none" }}
                                            onChange={handleImageUpload}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid size={{ xl: 9, lg: 9, md: 9, sm: 8.5, xs: 12 }}>
                                    <Grid container sx={{ justifyContent: 'space-between', gap: "10px", rowGap: { xs: '15px', sm: '25px' } }}>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        First Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter First Name'
                                                        autoComplete='off'
                                                        value={memberPayloadDetails?.firstName ? memberPayloadDetails?.firstName : ""}
                                                        onChange={(e) => {
                                                            const input = e.target.value;
                                                            const onlyLetters = input.replace(/[^a-zA-Z\s]/g, "");
                                                            handleInputChange("firstName", onlyLetters);
                                                        }}
                                                        error={!!validationErrors.firstName}
                                                        helperText={validationErrors.firstName}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                color: "rgb(255 38 22)",
                                                                fontSize: "13px",
                                                                fontWeight: '600',
                                                                marginLeft: "0px"
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Last Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Last Name'
                                                        autoComplete='off'
                                                        value={memberPayloadDetails.lastName ? memberPayloadDetails.lastName : ""}
                                                        onChange={(e) => {
                                                            const input = e.target.value;
                                                            const onlyLetters = input.replace(/[^a-zA-Z\s]/g, "");
                                                            handleInputChange("lastName", onlyLetters);
                                                        }}
                                                        error={!!validationErrors.lastName}
                                                        helperText={validationErrors.lastName}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                color: "rgb(255 38 22)",
                                                                fontSize: "13px",
                                                                fontWeight: '600',
                                                                marginLeft: "0px"
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Email <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Email'
                                                        autoComplete='off'
                                                        value={memberPayloadDetails?.memberEmail ? memberPayloadDetails?.memberEmail : ""}
                                                        onChange={(e) => handleInputChange("memberEmail", e.target.value)}
                                                        error={!!validationErrors.memberEmail}
                                                        helperText={validationErrors.memberEmail}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                color: "rgb(255 38 22)",
                                                                fontSize: "13px",
                                                                fontWeight: '600',
                                                                marginLeft: "0px"
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Member Designation Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Designation Name'
                                                        autoComplete='off'
                                                        value={memberPayloadDetails?.memberTitle ? memberPayloadDetails?.memberTitle : ""}
                                                        onChange={(e) => handleInputChange("memberTitle", e.target.value)}
                                                        error={!!validationErrors.memberTitle}
                                                        helperText={validationErrors.memberTitle}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                color: "rgb(255 38 22)",
                                                                fontSize: "13px",
                                                                fontWeight: '600',
                                                                marginLeft: "0px"
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Phone Number <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Phone Number'
                                                        autoComplete='off'
                                                        value={memberPayloadDetails?.memberPhone ? memberPayloadDetails?.memberPhone : ""}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value.replace(/\D/g, "");
                                                            handleInputChange("memberPhone", numericValue);
                                                        }}
                                                        error={!!validationErrors.memberPhone}
                                                        helperText={validationErrors.memberPhone}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                color: "rgb(255 38 22)",
                                                                fontSize: "13px",
                                                                fontWeight: '600',
                                                                marginLeft: "0px"
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Set as Default
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={memberPayloadDetails.isDefault ? memberPayloadDetails.isDefault : false}
                                                                icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                                checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                                sx={{ padding: "0px 8px" }}
                                                                onChange={(e) => handleInputChange("isDefault", e.target.checked)}
                                                            />
                                                        }
                                                        label=""
                                                        className={styles.signinCheckboxLabel}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid> */}

                                        <Grid size={{ xs: 12 }}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Description
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Description'
                                                        autoComplete='off'
                                                        value={memberPayloadDetails?.description ? memberPayloadDetails?.description : ''}
                                                        onChange={(e) => handleInputChange("description", e.target.value)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: '40px 0px 0px' }}>
                            <Grid container sx={{ justifyContent: 'center', gap: '25px', alignItems: 'center' }}>
                                <Grid className={styles.atDialogBtnItem}>
                                    <GlobalButton
                                        value='Cancel'
                                        size='medium'
                                        fullWidth={true}
                                        variant='outlined'
                                        className={globalStyles.globalButtonOutlinedStyleV1}
                                        onClick={() => {
                                            setFlagOpenNewMemberDialog(false)
                                            setMemberPayloadDetails(blankMemberPayload);
                                        }}
                                    />
                                </Grid>
                                <Grid className={styles.atDialogBtnItem}>
                                    <GlobalButton
                                        value='Save'
                                        size='medium'
                                        fullWidth={true}
                                        variant='contained'
                                        className={globalStyles.globleButtonStyleV1}
                                        onClick={() => {
                                            handleSaveNewMemberDetails()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AcrylicNewMemberDialog